module.exports = __webpack_public_path__ + "static/media/tag-empty-glow.40245f2f.svg";